import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { TokenStorageService } from '@app/core/services/token-storage.service';
import { ReferralUser } from '@app/core/interfaces/user.interface';
import { SaveResult } from '@app/shared/interfaces/saveResult.interface';
import {Appointment, NgAppointments} from '@app/shared/interfaces/appointment.interface';
import {AppointmentSearchParams} from "@app/shared/interfaces/appointmentSearchParams.interface";

enum EP {
  GetAccountSettings = '/users',
}

@Injectable({
    providedIn: 'root'
})
export class ReferralDashboardService {
  private readonly nextGenBaseUrl = `${environment.apiUrl}/nextgen/appointments`;
  constructor(
    private http: HttpClient,
    private tokenService: TokenStorageService
    ) { }

  getReferralAccountSettings$(): Observable<ReferralUser> {
    const userId = this.tokenService.getEffectiveUser()?.id;
    return this.http.get<ReferralUser>(`${environment.apiUrl}/users/referral/${userId}/settings-details`);
  }

  updateReferralAccountSettings$(updatedReferralUser: ReferralUser) {
    const userId = this.tokenService.getEffectiveUser()?.id;
    return this.http.put<SaveResult>(`${environment.apiUrl}/users/referral/${userId}/settings-details`, updatedReferralUser);
  }

  discardReferralUserPendingClinicProviderChanges$(): Observable<SaveResult> {
    const userId = this.tokenService.getEffectiveUser()?.id;
    return this.http.post<SaveResult>(
      `${environment.apiUrl}/users/referral/${userId}/settings-details/discard-clinic-changes`,
      {}
    );
  }

  getReferralUserAppointments$(filter: AppointmentSearchParams): Observable<NgAppointments> {
    const sendParams = { ...filter }
    return this.http.get<NgAppointments>(this.nextGenBaseUrl + "/total", {
      params: sendParams
    });
  }

  getReferralUserAppointmentDetails$(ids: string[]): Observable<NgAppointments> {
    return this.http.post<NgAppointments>(this.nextGenBaseUrl, ids);
  }
}
